import React from 'react';
import { Search, PenTool, Code2, Rocket } from 'lucide-react';

const steps = [
    {
        icon: <Search className="w-6 h-6" />,
        title: 'Discovery',
        description: 'We audit your current processes to identify bottlenecks and automation opportunities.',
    },
    {
        icon: <PenTool className="w-6 h-6" />,
        title: 'Design',
        description: 'We map out the perfect workflow architecture tailored to your specific business needs.',
    },
    {
        icon: <Code2 className="w-6 h-6" />,
        title: 'Build',
        description: 'Our engineers build the automation using n8n, custom code, and AI integration.',
    },
    {
        icon: <Rocket className="w-6 h-6" />,
        title: 'Deploy',
        description: 'We launch the system, train your team, and provide ongoing monitoring and support.',
    },
];

const Process: React.FC = () => {
    return (
        <section id="process" className="py-24 bg-navy-900 relative">
            <div className="max-w-7xl mx-auto px-6">
                <div className="text-center mb-16">
                    <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                        How We Work
                    </h2>
                    <p className="text-text-muted">
                        From chaos to clarity in four simple steps.
                    </p>
                </div>

                <div className="relative grid md:grid-cols-4 gap-8">
                    {/* Connecting Line (Desktop) */}
                    <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-gradient-to-r from-brand-cyan/0 via-brand-cyan/30 to-brand-cyan/0" />

                    {steps.map((step, index) => (
                        <div key={index} className="relative pt-8 text-center group">
                            <div className="relative z-10 w-16 h-16 mx-auto rounded-2xl bg-navy-800 border border-white/[0.1] grid place-items-center text-white mb-6 group-hover:border-brand-cyan transition-colors shadow-lg shadow-black/50">
                                {step.icon}
                                <div className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-brand-cyan text-navy-900 text-xs font-bold grid place-items-center">
                                    {index + 1}
                                </div>
                            </div>

                            <h3 className="text-lg font-bold text-white mb-3">{step.title}</h3>
                            <p className="text-text-muted text-sm leading-relaxed px-4">
                                {step.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Process;
